export default "__VITE_ASSET__C1Ff1XRn__"